<ng-container thr-parent-form>
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-6">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <mat-label>{{ 'form.social-name' | translate }}</mat-label>
                    <input name="plpName" matInput [placeholder]="'form.hints.social-name' | translate" required maxlength="60" [disabled]="client.disabled" [(ngModel)]="client.name" #nameCtrl="ngModel" />
                    <mat-error *ngIf="nameCtrl.hasError('required')">
                        {{ 'form.validation.required' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-6">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <mat-select name="plpCountry" [placeholder]="'form.country-social' | translate" required [disabled]="client.disabled" [(ngModel)]="client.country" #countryCtrl="ngModel">
                        <mat-option *ngFor="let country of countries" [value]="country.id.value">
                            {{ country.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="countryCtrl.hasError('required')">
                        {{ 'form.validation.required' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-6">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <mat-select name="plpDocumentType" [placeholder]="'form.document' | translate" [disabled]="client.disabled" [(ngModel)]="client.docType">
                        <ng-template ngFor let-type [ngForOf]="client.allowedDocTypes">
                            <mat-option [value]="type">{{ 'form.document-types.' + type | translate }}</mat-option>
                        </ng-template>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-6">
                <ng-container [ngSwitch]="client.docType">
                    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchDefault>
                        <mat-label>{{ 'form.document-types.CI' | translate }}</mat-label>
                        <input name="plpDocument" matInput [placeholder]="'form.hints.cif' | translate" required minlength="9" maxlength="15" cif [clientExists]="!isClientPortal" [docType]="DocumentType.CIF" [disabled]="client.disabled" [(ngModel)]="client.docId" #documentCtrl="ngModel"
                        />
                        <mat-error *ngIf="documentCtrl.hasError('cif') && !documentCtrl.hasError('required')">
                            {{ 'form.validation.invalid.document' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                         ">
                            {{ 'form.validation.client-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                !documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                        ">
                            {{ 'form.validation.client-exists-other-agent' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                </ng-container>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-sm-6">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <mat-label>{{ 'form.legalEntityID' | translate }}</mat-label>
                    <input name="plplegalEntityId" matInput [placeholder]="'form.hints.legalEntityId' | translate" maxlength="20" lei [disabled]="client.disabled" [(ngModel)]="client.legalEntityId" #legalEntityIdCtrl="ngModel" />
                    <mat-error *ngIf="legalEntityIdCtrl.hasError('lei')">
                        {{ 'form.validation.lei' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-6">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <mat-label>{{ 'form.expired-document-date.LEI' | translate }}</mat-label>
                    <input name="pnpLegalEntityIdExpiration" matInput [min]="today" [matDatepicker]="legalEntityIdExpirationPicker" maxlength="10" [disabled]="client.disabled" [placeholder]="'form.hints.date' | translate" [(ngModel)]="client.legalEntityIdExpirationDate"
                        #legalEntityIdExpirationCtrl="ngModel" />
                    <mat-datepicker-toggle matSuffix [for]="legalEntityIdExpirationPicker"></mat-datepicker-toggle>
                    <mat-datepicker #legalEntityIdExpirationPicker [disabled]="client.disabled"></mat-datepicker>
                    <mat-error *ngIf="!legalEntityIdExpirationCtrl.valid">
                        {{ 'form.validation.expired-lei-date' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-md-6">
                <ng-container *ngIf="!isClientPortal">
                    <mat-checkbox name="plpNotPhone" [(ngModel)]="client.phoneExonerate" (ngModelChange)="onExonerate()" *ngIf="!client.disabled; else elsePhone">
                        {{ 'form.not-phone' | translate }}
                    </mat-checkbox>
                    <ng-template #elsePhone>
                        <mat-checkbox name="plpNotPhone" [disabled]="true">
                            {{ 'form.not-phone' | translate }}
                        </mat-checkbox>
                    </ng-template>
                </ng-container>
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-12">
                        <mat-form-field class="full-width mb-3 mb-sm-4">
                            <input name="plpPhone" matInput [placeholder]="'form.phone' | translate" required minlength="9" pattern="[\d\+]+" existsInContract [clientId]="client.id" [field]="'phone'" [otherValue]="currentAttorneyInFact ? currentAttorneyInFact.phone : null" [phoneExists]="!isClientPortal"
                                [disabled]="client.phoneExonerate || client.disabled" [(ngModel)]="client.phone" #phoneCtrl="ngModel" />
                            <mat-error *ngIf="
                                    (phoneCtrl.hasError('minlength') || phoneCtrl.hasError('pattern')) && !phoneCtrl.hasError('required')
                             ">
                                {{ 'form.validation.invalid.phone' | translate }}
                            </mat-error>
                            <mat-error *ngIf="phoneCtrl.hasError('phoneExists') && !phoneCtrl.hasError('required')">
                                {{ 'form.validation.phone-exists' | translate }}
                            </mat-error>
                            <mat-error *ngIf="phoneCtrl.hasError('existsInContract')">
                                {{ 'form.validation.phone-exists-in-contract' | translate }}
                            </mat-error>
                            <mat-error *ngIf="phoneCtrl.hasError('required')">
                                {{ 'form.validation.required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12">
                        <mat-form-field class="full-width mb-3 mb-sm-4">
                            <input name="plpPhoneConfirm" matInput [placeholder]="'form.phone-confirm' | translate" required minlength="9" pattern="[\d\+]+" [equalTo]="phoneCtrl" [disabled]="client.phoneExonerate || client.disabled" [(ngModel)]="client.phoneConfirm" #phoneConfirmCtrl="ngModel"
                            />
                            <mat-error *ngIf="
                                    (phoneConfirmCtrl.hasError('minlength') || phoneConfirmCtrl.hasError('pattern')) &&
                                    !phoneConfirmCtrl.hasError('required')
                             ">
                                {{ 'form.validation.invalid.phone' | translate }}
                            </mat-error>
                            <mat-error *ngIf="
                                    phoneConfirmCtrl.hasError('equalTo') &&
                                    !phoneConfirmCtrl.hasError('minlength') &&
                                    !phoneConfirmCtrl.hasError('pattern') &&
                                    !phoneConfirmCtrl.hasError('required')
                             ">
                                {{ 'form.validation.equalTo.phone' | translate }}
                            </mat-error>
                            <mat-error *ngIf="phoneConfirmCtrl.hasError('required')">
                                {{ 'form.validation.required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <ng-container *ngIf="!isClientPortal">
                    <mat-checkbox name="plpNotEmail" [(ngModel)]="client.emailExonerate" (ngModelChange)="onExonerate()" *ngIf="!client.disabled; else elseEmail">
                        {{ 'form.not-email' | translate }}
                    </mat-checkbox>
                    <ng-template #elseEmail>
                        <mat-checkbox name="plpNotEmail" [disabled]="true">
                            {{ 'form.not-email' | translate }}
                        </mat-checkbox>
                    </ng-template>
                </ng-container>
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-12">
                        <mat-form-field class="full-width mb-3 mb-sm-4">
                            <input name="plpEmail" matInput [placeholder]="'form.email' | translate" required emailWithDot existsInContract [clientId]="client.id" [field]="'email'" [otherValue]="currentAttorneyInFact ? currentAttorneyInFact.email : null" [emailExists]="!isClientPortal"
                                [disabled]="client.emailExonerate || client.disabled" [(ngModel)]="client.email" #emailCtrl="ngModel" />
                            <mat-error *ngIf="emailCtrl.hasError('email') && !emailCtrl.hasError('required')">
                                {{ 'form.validation.invalid.email' | translate }}
                            </mat-error>
                            <mat-error *ngIf="emailCtrl.hasError('emailExists') && !emailCtrl.hasError('required')">
                                {{ 'form.validation.email-exists' | translate }}
                            </mat-error>
                            <mat-error *ngIf="emailCtrl.hasError('existsInContract')">
                                {{ 'form.validation.email-exists-in-contract' | translate }}
                            </mat-error>
                            <mat-error *ngIf="emailCtrl.hasError('required')">
                                {{ 'form.validation.required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12">
                        <mat-form-field class="full-width mb-3 mb-sm-4">
                            <input name="plpEmailConfirm" matInput [placeholder]="'form.email-confirm' | translate" required emailWithDot [equalTo]="emailCtrl" [disabled]="client.emailExonerate || client.disabled" [(ngModel)]="client.emailConfirm" #emailConfirmCtrl="ngModel" />
                            <mat-error *ngIf="emailConfirmCtrl.hasError('email') && !emailConfirmCtrl.hasError('required')">
                                {{ 'form.validation.invalid.email' | translate }}
                            </mat-error>
                            <mat-error *ngIf="
                                    emailConfirmCtrl.hasError('equalTo') &&
                                    !emailConfirmCtrl.hasError('email') &&
                                    !emailConfirmCtrl.hasError('required')
                             ">
                                {{ 'form.validation.equalTo.email' | translate }}
                            </mat-error>
                            <mat-error *ngIf="emailConfirmCtrl.hasError('required')">
                                {{ 'form.validation.required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mb-2 mb-sm-3">
                <mat-checkbox name="plpLegal" required [(ngModel)]="client.acceptLegal">
                    <span>
                        {{ 'form.accept-legal' | translate }}
                        <a href="javascript:void(0)" (click)="openDialog()">{{ 'form.info-rgpd' | translate }} </a>
                        <span [innerHTML]="'form.and-accept-privacy-policy' | translate"></span>
                    </span>
                    <span class="d-block text-error" *ngIf="!client.acceptLegal">
                        {{ 'form.validation.accept-legal' | translate }}
                    </span>
                </mat-checkbox>
            </div>
            <div class="col-12 mb-2 mb-sm-3">
                <mat-checkbox name="plpMarketing" [disabled]="client.disabled" [(ngModel)]="client.acceptMarketing">
                    <strong [innerHTML]="'form.accept-marketing' | translate"></strong>:
                    <span [innerHTML]="'form.accept-marketing-text' | translate"></span>
                </mat-checkbox>
            </div>
        </div>

        <div class="row" *ngIf="(client.phoneExonerate || client.emailExonerate) && !client.disabled">
            <div class="col-12">
                <p class="mat-caption text-error font-italic">
                    {{ 'form.validation.exonerate' | translate }}
                </p>
            </div>
        </div>
    </div>
</ng-container>
